module.exports = __webpack_public_path__ + "img/1b831bd.png";